import {Record} from 'immutable';

import type * as Types from './types';

interface IFileRecord {
    readonly name: string;
    readonly type: string;
    readonly id: string;
    readonly height: number;
    readonly width: number;
    readonly uploadProgress: number;
    readonly previewUrl: string;
    readonly thumbnailUrl: string;
    readonly tinyThumbnailUrl: string | null;
    readonly item: Types.PersistedObject | Types.NonpersistedObject | null;
    readonly file: any;
    readonly videoDuration: number;
    readonly url: string;
}

class FileRecord extends Record<IFileRecord>({
    name: String(''),
    type: String(''),
    id: String(''),
    height: 1080,
    width: 1080,
    uploadProgress: Number(0),
    previewUrl: String(''),
    thumbnailUrl: String(''),
    tinyThumbnailUrl: null,
    item: null,
    file: File,
    videoDuration: Number(0),
    url: '',
}) {}

type InferRecord<T extends Record<any>> = T extends Record<infer U> ? U : never;

export const serialize = (record: FileRecord): Omit<InferRecord<FileRecord>, 'file'> => {
    // Note that we're purposely leaving out the 'File' object here when serializing.
    // The main reason for that is that it's not necessary to serialize (e.g. to JSON) the file.
    //
    // However, another underlying reason not to is that we in the file upload epics store the XHR request object
    // on the file object for the purpose of later being able to easily abort the upload.
    // Reference: https://github.com/famly/app/blob/bd16fda7e4f9e8412f93d2b18ecd8a16c15dd149/app/react/components/file-upload/epics.js#L128

    return {
        name: record.name,
        type: record.type,
        id: record.id,
        height: record.height,
        width: record.width,
        uploadProgress: record.uploadProgress,
        previewUrl: record.previewUrl,
        thumbnailUrl: record.thumbnailUrl,
        tinyThumbnailUrl: record.tinyThumbnailUrl,
        item: record.item,
        videoDuration: record.videoDuration,
        url: record.url,
    };
};

export const deserialize = (object: ReturnType<typeof serialize>) => {
    return new FileRecord(object);
};

export default FileRecord;
